// extracted by mini-css-extract-plugin
export var panelCopyActiveToInactive = "OfferingPanels-module--panelCopyActiveToInactive--49fe7";
export var panelCopyInactiveToActive = "OfferingPanels-module--panelCopyInactiveToActive--1830e";